import { onMounted, type Ref, ref, watch } from 'vue'

import { getUserSetting, setUserSetting } from '@/common/utils/userSettings'

const DEFAULT_PAGE_SIZE = 25

type UsePaginationParams = {
  currentUserId: number
  userSettingsKey: string
  pageSize: number
}
type UsePaginationReturn = {
  currentPage: Ref<number>
  defaultPageSize: number
  itemsPerPage: Ref<number>
}

export function usePagination ({
    currentUserId,
    userSettingsKey,
    pageSize = DEFAULT_PAGE_SIZE,
}: UsePaginationParams): UsePaginationReturn {
  const currentPage = ref(1)
  const itemsPerPage = ref(pageSize)

  function setPageSizeInUserSettings (size: number) {
    setUserSetting(currentUserId, userSettingsKey, size)
  }

  onMounted(() => {
    const itemsPerPageStorage = getUserSetting(currentUserId, userSettingsKey)
    const size = itemsPerPageStorage !== null ? parseInt(itemsPerPageStorage) : pageSize

    itemsPerPage.value = size
    setPageSizeInUserSettings(size)
  })

  watch(itemsPerPage, (newPageSize) => {
    setPageSizeInUserSettings(newPageSize)
    currentPage.value = 1
  })

  return {
    currentPage,
    defaultPageSize: pageSize,
    itemsPerPage,
  }
}
